import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

const PlayIcon = () => (
    <svg className="youtube-icon" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 61 60" fill="none">
        <path
            d="M56.8514 16.05C56.5545 14.8635 55.9496 13.7764 55.0981 12.8985C54.2465 12.0206 53.1783 11.383 52.0014 11.05C47.7014 10 30.5014 10 30.5014 10C30.5014 10 13.3014 10 9.00143 11.15C7.82455 11.483 6.75637 12.1206 5.9048 12.9985C5.05322 13.8764 4.4484 14.9635 4.15143 16.15C3.36447 20.5139 2.97952 24.9408 3.00143 29.375C2.97338 33.8426 3.35835 38.3033 4.15143 42.7C4.47883 43.8496 5.0972 44.8954 5.94679 45.7362C6.79638 46.577 7.84848 47.1845 9.00143 47.5C13.3014 48.65 30.5014 48.65 30.5014 48.65C30.5014 48.65 47.7014 48.65 52.0014 47.5C53.1783 47.167 54.2465 46.5294 55.0981 45.6515C55.9496 44.7736 56.5545 43.6865 56.8514 42.5C57.6323 38.169 58.0172 33.7758 58.0014 29.375C58.0295 24.9074 57.6445 20.4467 56.8514 16.05Z"
            fill="#FF0200"
        />
        <path d="M24.875 37.5502L39.25 29.3752L24.875 21.2002V37.5502Z" fill="white" />
    </svg>
);
const VIDEO_MAP: any = {
    us: [
        'https://www.youtube.com/embed/JcKq6neGxXk?si=XoG9IfD3Qe1fy763',
        'https://www.youtube.com/embed/3aTQSXtpHmU?si=SgOuS9AsRGwW_ncU',
        'https://www.youtube.com/embed/WE9Ct6Pz8nw?si=yP7s35u6hlve7XDJ',
        // 'https://www.youtube.com/embed/hR8qv5V3LWA?si=GdIythnNV9rTrr47',
        'https://www.youtube.com/embed/hMVkwZ5ZUCI?si=VcflURd5CpwNe82c',
    ],
    ca: [
        'https://www.youtube.com/embed/3aTQSXtpHmU?si=SgOuS9AsRGwW_ncU',
        'https://www.youtube.com/embed/WE9Ct6Pz8nw?si=yP7s35u6hlve7XDJ',
        'https://www.youtube.com/embed/hR8qv5V3LWA?si=GdIythnNV9rTrr47',
        'https://www.youtube.com/embed/hMVkwZ5ZUCI?si=VcflURd5CpwNe82c',
    ],
    au: [
        'https://www.youtube.com/embed/4kjikCOInz0?si=qImItqc5-XZgGDfv',
        'https://www.youtube.com/embed/o8Ik1SqQuiM?si=dzMTpSqhcvC0r8RT',
        'https://www.youtube.com/embed/bcFBxKdwI8Q?si=QKcrD_V05vVp0yJ9',
        'https://www.youtube.com/embed/jSKhDyULFHY?si=RV8iBK30pU6BkP0I',
    ],
    kr: [
        'https://www.youtube.com/embed/3aTQSXtpHmU?si=G222AH0Mfbtg6Fvn',
        'https://www.youtube.com/embed/WE9Ct6Pz8nw?si=O-4nXbYF1WispGO6',
        'https://www.youtube.com/embed/hR8qv5V3LWA?si=VCH0Ef5A8Tsfl5fc',
        'https://www.youtube.com/embed/hMVkwZ5ZUCI?si=3ownG6RjM9OhiaV3',
    ],
};
const POSTER_MAP: any = {
    us: [
        'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711433308748/12_1.jpg',
        '/responsive/picture/power-backup/12_1.jpg',
        '/responsive/picture/power-backup/12_2.jpg',
        // '/responsive/picture/power-backup/12_3.jpg',
        '/responsive/picture/power-backup/12_4.jpg',
    ],
    ca: [
        '/responsive/picture/power-backup/12_1.jpg',
        '/responsive/picture/power-backup/12_2.jpg',
        '/responsive/picture/power-backup/12_3.jpg',
        '/responsive/picture/power-backup/12_4.jpg',
    ],
    au: [
        '/responsive/picture/power-backup/12_1_au.jpg',
        '/responsive/picture/power-backup/12_2_au.jpg',
        '/responsive/picture/power-backup/12_3_au.jpg',
        '/responsive/picture/power-backup/12_4_au.jpg',
    ],
    kr: [
        '/responsive/picture/power-backup/12_1.jpg',
        '/responsive/picture/power-backup/12_2.jpg',
        '/responsive/picture/power-backup/12_3.jpg',
        '/responsive/picture/power-backup/12_4.jpg',
    ],
};

export default function L() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const [source, setSource] = useState('');

    const cards: any = [
        {
            img: POSTER_MAP[locale]?.[0],
            text: t('secL_list1'),
            video: VIDEO_MAP[locale]?.[0],
        },
        {
            img: POSTER_MAP[locale]?.[1],
            text: t('secL_list2'),
            video: VIDEO_MAP[locale]?.[1],
        },
        {
            img: POSTER_MAP[locale]?.[2],
            text: t('secL_list3'),
            video: VIDEO_MAP[locale]?.[2],
        },
        {
            img: POSTER_MAP[locale]?.[3],
            text: t('secL_list4'),
            video: VIDEO_MAP[locale]?.[3],
        },
    ];

    return (
        <div id="power-backup-L" className={`power-backup-L ${css['power-backup-L']}`}>
            <div className="text-box">
                <p className="title">{t('secL_title')}</p>
            </div>
            <div className="swiper-container">
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={20}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {cards?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => setSource(card?.video)}>
                            <EFPicture src={card?.img} srcPad={card?.img} srcMobile={card?.img} alt={card?.text} />
                            <PlayIcon />
                            <p className="card-text">{card?.text}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
